import t from"@mui/material/Box";import{styled as e}from"@mui/material/styles";const m=e(t)((({theme:t})=>({textAlign:"center",color:t.palette.grey900.main,"& p":{margin:0}})));export{m as Container};
//# sourceMappingURL=styles.js.map
